import theme from 'stories/utils/theme'
import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface Props {
    children: ReactNode
    height?: number
    fullWidthMobile?: boolean
    width?: number
    hasBorder?: boolean
    hideBorderRadius?: boolean
    hasShadow?: boolean
    backgroundColor?: string
    padding?: number
    isClickable?: boolean
    setMobileSize?: boolean
    borderColor?: string
    borderBottom?: string
    hasStandardShadow?: boolean
    customBorder?: string
    heightFitContent?: boolean
    showOverflow?: boolean
}

interface ContainerProps {
    height?: number
    fullWidthMobile?: boolean
    width?: number
    hasBorder?: boolean
    hideBorderRadius?: boolean
    hasShadow?: boolean
    backgroundColor?: string
    padding?: number
    isClickable?: boolean
    setMobileSize?: boolean
    borderColor?: string
    borderBottom?: string
    hasStandardShadow?: boolean
    customBorder?: string
    heightFitContent?: boolean
    showOverflow?: boolean
}

const mobileFullWidth = `
    border-radius: 0px;
    width: 100vw;
`

const Container = styled.div<ContainerProps>`
    min-height: ${({ height }) => (height ? `${height}px` : 'auto')};
    min-width: ${({ width }) => (width ? `${width}px` : 'auto')};

    background: ${({ backgroundColor }) => backgroundColor ?? '#fff'};
    box-shadow: ${({ hasShadow }) => (hasShadow ? `4px 4px 0px ${theme.colors.accentBlue}` : '')};
    border-radius: ${({ hideBorderRadius }) => (hideBorderRadius ? 0 : theme.borderRadius.normal)};
    border: ${({ hasBorder, borderColor }) => (hasBorder ? `3px solid ${borderColor ?? theme.colors.accentBlue}` : 'none')};
    ${({ fullWidthMobile }) =>
        fullWidthMobile
            ? css`
                  ${mobileFullWidth}
              `
            : ''}
    ${({ heightFitContent }) =>
        heightFitContent
            ? css`
                  height: fit-content;
              `
            : ''}
    ${({ borderBottom }) =>
        borderBottom
            ? css`
                  border-bottom: ${borderBottom};
              `
            : ''}
    ${({ hasStandardShadow }) =>
        hasStandardShadow
            ? css`
                  box-shadow: 0px 4px 16px 0px #0000001f;
              `
            : ''}
    ${({ customBorder }) =>
        customBorder
            ? css`
                  border: ${customBorder};
              `
            : ''}
    padding: ${({ padding }) => (padding || padding === 0 ? `${padding}px` : '3%')};
    overflow: ${({ showOverflow }) => (showOverflow ? 'visible' : 'hidden')};
    z-index: 5;
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
    @media (max-width: 750px) {
        ${({ setMobileSize, width, height }) =>
            setMobileSize
                ? css`
                      min-height: ${height ? `${height}px` : 'none'};
                      min-width: ${width ? `${width}px` : 'none'};
                  `
                : css`
                      min-height: auto;
                      min-width: auto;
                  `}
    }
`

const CardContainer = ({
    height,
    children,
    fullWidthMobile,
    width,
    hasBorder,
    hideBorderRadius,
    hasShadow,
    backgroundColor,
    padding,
    isClickable,
    setMobileSize,
    borderColor,
    borderBottom,
    hasStandardShadow,
    customBorder,
    heightFitContent,
    showOverflow,
}: Props) => (
    <Container
        height={height}
        width={width}
        hasBorder={hasBorder}
        hasShadow={hasShadow}
        hideBorderRadius={hideBorderRadius}
        padding={padding}
        fullWidthMobile={fullWidthMobile ?? false}
        isClickable={isClickable}
        backgroundColor={backgroundColor}
        setMobileSize={setMobileSize}
        borderColor={borderColor}
        borderBottom={borderBottom}
        hasStandardShadow={hasStandardShadow}
        customBorder={customBorder}
        heightFitContent={heightFitContent}
        showOverflow={showOverflow}
        className="container"
    >
        {children}
    </Container>
)

export default CardContainer
